import { cn } from '@/lib/utils';

/** Fireflies', Fathom's, Gong's and Notion's own marks (public/logos), for the
 * surfaces that connect to them (Integrations) or show what they synced
 * (Knowledge). */
export function FirefliesIcon({ className }: { className?: string }) {
  return (
    <img
      src='/logos/fireflies.svg'
      alt=''
      aria-hidden
      className={cn('shrink-0 object-contain', className)}
    />
  );
}

export function FathomIcon({ className }: { className?: string }) {
  return (
    <img
      src='/logos/fathom.svg'
      alt=''
      aria-hidden
      className={cn('shrink-0 object-contain', className)}
    />
  );
}

export function GongIcon({ className }: { className?: string }) {
  return (
    <img
      src='/logos/gong.svg'
      alt=''
      aria-hidden
      className={cn('shrink-0 object-contain', className)}
    />
  );
}

export function NotionIcon({ className }: { className?: string }) {
  return (
    <img
      src='/logos/notion.svg'
      alt=''
      aria-hidden
      className={cn('shrink-0 object-contain', className)}
    />
  );
}
